import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form, TextArea, Grid } from 'semantic-ui-react'
import $ from "jquery";
import Server from '../../../functions/server';
import Executive from '../../dropdown/executive';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    create: 'true'
  };

  componentDidMount() {
    this.getState();
  }

  componentDidUpdate(props) {
    if (props.customerId != this.props.customerId) {
      this.getState();
    }
  }

  getState() {
    let data = this.props.data;
    let due_date, comments, follwedby;
    if (this.props.statementId == null) {

    }
    else {
      data.map((z) => {
        if (this.props.statementId == z.statement_id) {
          due_date = z.due_date;
          comments = z.comments;
          follwedby = z.follow_by;
        }
      });
      this.setState({
        dueDate: due_date,
        comments: comments,
        followedBy: follwedby,
      })
    }
  }

  submit() {
    let context = this;
    let data1 = [];
    let url;
    if (this.state.create == 'true') {
      url = Server() + 'statement/insert.php';
      data1 = { 'dueDate': this.state.dueDate, 'comments': this.state.comments, 'followedBy': this.state.followedBy, 'customerId': this.props.customerId };
    }
    else {
      url = Server() + 'statement/update.php';
      data1 = { 'dueDate': this.state.dueDate, 'comments': this.state.comments, 'followedBy': this.state.followedBy, 'statementId': this.props.statementId };
    }
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.props.getHistory();
          if (context.state.create == 'true') {
            context.props.getToday();
            context.props.close();
          }
          else {
            let data = context.props.data;
            data.map((z) => {
              if (context.props.statementId == z.statement_id) {
                z.due_date= context.state.dueDate;
                z.comments= context.state.comments;
                z.follow_by= context.state.followedBy;
                z.follower_name = context.state.executiveName;
              }
            });
            context.props.close();
            context.props.update(data);
          }
        }
        else {
          alert('Try Again!!!')
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  }

  update(type, value, executiveData) {
    let executiveName;
    executiveData.map((z) => {
      if (value == z.id) {
        executiveName = z.name;
      }
    })
    this.setState({
      followedBy: value,
      executiveName: executiveName
    })
  }

  render() {
    const { classes } = this.props;
    let dueDate = this.state.dueDate;
    let comments = this.state.comments;
    return (
      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.props.openUpdates} onClose={ () => { this.props.close() }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Follow-by and Comments and Due-date</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                <input type="date" id="date" style={{height: 30}} value={dueDate} onChange={this.handleChange('dueDate')} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={7}>
                <Executive update={this.update.bind(this)} selectExecutive={this.state.followedBy} />
              </Grid.Column>
            </Grid>
            <Form>
              <br/>
              <TextArea placeholder='Remarks' value={comments} onChange={this.handleChange('comments')} style={{ minHeight: 100 }} />
            </Form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">
              Submit
            </Button>
            <Button onClick={ () => { this.props.close() }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
